import { useContext, useMemo, useState } from "react";
import AuthContext from "../../contexts/AuthContext/AuthContext";

export default function YoungLawyerWarningModal() {
  const { user } = useContext(AuthContext);
  const [dismissed, setDismissed] = useState(false);

  const shouldShow = useMemo(() => {
    if (dismissed || !user) return false;
    return (
      user.jovem_advogado_status === "approved" &&
      user.jovem_advogado_warning === true
    );
  }, [dismissed, user]);

  if (!shouldShow) return null;

  const daysRemaining = user.jovem_advogado_days_remaining ?? 0;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.45)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <div
        style={{
          maxWidth: "560px",
          width: "100%",
          background: "#fff",
          borderRadius: "12px",
          padding: "1.25rem",
          boxShadow: "0 12px 28px rgba(0,0,0,0.2)",
        }}
      >
        <h3 style={{ marginBottom: "0.75rem" }}>
          Benefício Jovem Advogado perto do limite
        </h3>
        <p style={{ marginBottom: "0.75rem" }}>
          Faltam <strong>{daysRemaining} dias</strong> para o fim da sua janela de
          elegibilidade de cupom.
        </p>
        <p style={{ marginBottom: "1rem" }}>
          Entre em contato com a ADM para orientação de continuidade.
        </p>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          style={{
            background: "#0d6efd",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "0.5rem 1rem",
            cursor: "pointer",
          }}
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
